import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import Helmet from 'react-helmet';
import * as _ from 'lodash';
import { getSocialAccounts } from 'redux/modules/organization';
import { parseLink, resetComposebox, orgInitialState, updatePlatformCheckbox } from 'redux/modules/composeboxForm';
import { setInitialState } from 'redux/modules/composebox';
import { EmptyState, ModalTopBar } from 'components';
import { ComposeboxForm, ComposeboxPreview } from '../../components/Composebox';
import { AppLayout, ModalLayout, Navbar } from 'containers';
import { connect } from 'react-redux';
import { loadTimezone } from 'redux/modules/config';

var moment = require('moment');

var ComposeScreen = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    theme: state.theme,
    backUrls: state.composebox.backUrls,
    composeboxForm: state.composeboxForm["".concat(orgId)] || orgInitialState,
    composeboxInitialState: state.composebox.composeboxInitialState["".concat(orgId)],
    modalOpen: state.modalLayout.open
  };
}, {
  getSocialAccounts: getSocialAccounts,
  parseLink: parseLink,
  resetComposebox: resetComposebox,
  setInitialState: setInitialState,
  updatePlatformCheckbox: updatePlatformCheckbox
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(ComposeScreen, _Component);

  var _super = _createSuper(ComposeScreen);

  function ComposeScreen(props) {
    var _this;

    _classCallCheck(this, ComposeScreen);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "camelCaseIt", function (theString) {
      var stringArray = theString.split(' ');
      stringArray[0] = stringArray[0].toLowerCase();
      stringArray[1] = _.startCase(stringArray[1]);
      return stringArray.join('');
    });

    _defineProperty(_assertThisInitialized(_this), "confirmBeforeWipingValues", function () {
      var backUrl = _this.props.backUrls.hasOwnProperty(_this.props.organization.id) ? _this.props.backUrls[_this.props.organization.id.toString()] : "/org/".concat(_this.props.organization.id, "/schedule");

      if (!_.isEqual(_this.props.composeboxInitialState, _this.props.composeboxForm)) {
        if (window.confirm('Are you sure you want to leave? You will lose any unsaved changes.')) {
          _this.props.resetComposebox(_this.props.organization.id);

          browserHistory.push(backUrl);
        }
      } else {
        _this.props.resetComposebox(_this.props.organization.id);

        browserHistory.push(backUrl);
      }
    });

    _this.state = {
      postBtnText: PropTypes.string
    };
    return _this;
  }

  _createClass(ComposeScreen, [{
    key: "UNSAFE_componentWillMount",
    value:
    /** *********************************************************
     LIFECYCLE METHODS
     ***********************************************************/
    function UNSAFE_componentWillMount() {
      var _this2 = this;

      this.props.getSocialAccounts(this.props.organization.id).then(function () {
        // need to get the link info here, or the confirm alert will be triggered because props
        // will have changed when we parse the link (if we were to do it in LinkPostSection)
        if (_this2.props.composeboxForm.postType === 'linkPost' && _this2.props.composeboxForm.linkData.link && (!_this2.props.composeboxForm.linkData.title || !_this2.props.composeboxForm.linkData.description)) {
          _this2.props.parseLink(_this2.props.composeboxForm.linkData.link, _this2.props.organization.id).then(function () {
            _this2.props.setInitialState(_this2.props.composeboxForm, _this2.props.organization.id);
          });
        } else {
          // set the initial enter state for non-link posts
          _this2.props.setInitialState(_this2.props.composeboxForm, _this2.props.organization.id);
        }
      });
    }
  }, {
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this3 = this;

      var _this$props = this.props,
          organization = _this$props.organization,
          user = _this$props.user,
          isModal = _this$props.isModal,
          location = _this$props.location;
      var locationState = location.state ? location.state : {};
      var initialValues = locationState.initialValues ? locationState.initialValues : {};
      var modalView = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ModalTopBar, {
        handleClose: function handleClose() {
          return _this3.confirmBeforeWipingValues();
        },
        handleGoBack: function handleGoBack() {
          return _this3.confirmBeforeWipingValues();
        },
        theme: this.props.theme,
        postBtnText: this.state.postBtnText
      }), /*#__PURE__*/React.createElement("div", {
        className: "container",
        style: {
          maxWidth: '1200px'
        }
      }, organization.SocialAccounts && organization.SocialAccounts.length ? /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-sm-12 col-md-6",
        style: {
          padding: '12px 40px'
        }
      }, /*#__PURE__*/React.createElement(ComposeboxForm, null)), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-0 col-sm-0 col-md-6",
        style: {
          padding: '12px 40px'
        }
      }, /*#__PURE__*/React.createElement(ComposeboxPreview, null))) : /*#__PURE__*/React.createElement(EmptyState, {
        buttonLabel: "Connect Social Account",
        buttonOnClick: function buttonOnClick() {
          browserHistory.push("/org/".concat(_this3.props.organization.id, "/settings/social-accounts"));
        },
        text: "Mum's the word...until you connect a social account.",
        iconName: "fa fa-comment-o",
        style: {
          marginTop: 36
        }
      })));
      var nonModalView = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Navbar, {
        position: "fixed",
        text: "Likeable",
        params: _objectSpread({}, this.props.params)
      }), /*#__PURE__*/React.createElement(ModalTopBar, {
        handleClose: function handleClose() {
          return _this3.confirmBeforeWipingValues();
        },
        handleGoBack: function handleGoBack() {
          return _this3.confirmBeforeWipingValues();
        },
        theme: this.props.theme,
        postBtnText: this.state.postBtnText
      }), /*#__PURE__*/React.createElement(ModalLayout, {
        theme: this.props.theme
      }, modalView));
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Helmet, {
        title: "Compose Screen"
      }), isModal ? modalView : nonModalView);
    }
  }]);

  return ComposeScreen;
}(Component), _defineProperty(_class2, "propTypes", {
  organization: PropTypes.object.isRequired,
  backUrls: PropTypes.object
}), _temp)) || _class);
export default ComposeScreen;